export default "__VITE_ASSET__DkS7unkO__"